import withName from "../../hoc/withName";
import { InputNumber } from "primereact/inputnumber";


const InputNumberPrime = ({ value = null,setValue=null,onChange=null,piIcon=null,className="", piIconPos="right", ...inputNumberProps }) => {
    if(piIcon) return(
        <span className={`p-input-icon-${piIconPos}`}>
            <i className={`pi ${piIcon}`} />
            <InputNumber value={value} onChange={onChange?onChange:(e) => setValue(e.value)} {...inputNumberProps} />
        </span>
    );
    return (
        <>
            <InputNumber className={`input-number-prime ${className}`} value={value} onChange={onChange?onChange:(e) => setValue(e.value)} {...inputNumberProps} />
        </>
    );
};

export default withName(InputNumberPrime, "InputNumberPrime");
